import { render, staticRenderFns } from "./SanitasTabs.vue?vue&type=template&id=2ee1a56e&scoped=true&"
import script from "./SanitasTabs.vue?vue&type=script&lang=js&"
export * from "./SanitasTabs.vue?vue&type=script&lang=js&"
import style0 from "./SanitasTabs.vue?vue&type=style&index=0&id=2ee1a56e&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee1a56e",
  null
  
)

export default component.exports